import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addBeat, BeatLevel, Note } from "./beatApi";
import styles from "./BeatShared.module.css";

export default function AddBeat() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [bpm, setBpm] = useState(120);
  const [rhythm, setRhythm] = useState("4/4");
  const [level, setLevel] = useState<BeatLevel>(BeatLevel.beginner);
  const [duration, setDuration] = useState(0);
  const [fileUrl, setFileUrl] = useState("");
  const [notesRaw, setNotesRaw] = useState<string>("[]");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title || !fileUrl || !rhythm || !duration || !bpm || !level) {
      alert("Tüm alanlar zorunludur.");
      return;
    }

    let notes: Note[] = [];
    if (notesRaw && notesRaw.trim() !== "" && notesRaw.trim() !== "[]") {
      try {
        const parsed = JSON.parse(notesRaw);
        if (!Array.isArray(parsed))
          throw new Error("Note JSON dizisi geçersiz");
        notes = parsed;
      } catch (err) {
        alert("Notes JSON formatı hatalı: " + err);
        return;
      }
    }
    try {
      await addBeat({
        title,
        bpm,
        rhythm,
        genre: level as string, // level'i genre olarak kullan
        duration_seconds: duration,
        file_url: fileUrl,
        notes: JSON.stringify(notes), // notes'u string'e çevir
      });
      navigate("/beats");
    } catch (error) {
      alert("Beat eklenirken hata oluştu.");
      console.error(error);
    }
  };

  return (
    <div className={styles.tableContainer}>
      <h1 className={styles.title}>
        <span role="img" aria-label="nota">
          🎼
        </span>{" "}
        Yeni Beat Ekle
      </h1>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div>
          <label className={styles.label}>Başlık *</label>
          <input
            className={styles.input}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            placeholder="Beat başlığını giriniz"
          />
        </div>
        <div className={styles.grid2}>
          <div>
            <label className={styles.label}>BPM</label>
            <input
              type="number"
              className={styles.input}
              value={bpm}
              min="60"
              max="200"
              onChange={(e) => setBpm(parseInt(e.target.value) || 120)}
            />
          </div>
          <div>
            <label className={styles.label}>Ritim</label>
            <input
              className={styles.input}
              value={rhythm}
              onChange={(e) => setRhythm(e.target.value)}
              placeholder="4/4"
            />
          </div>
          <div>
            <label className={styles.label}>Seviye</label>
            <select
              className={styles.input}
              value={level}
              onChange={(e) => setLevel(e.target.value as BeatLevel)}
            >
              {Object.values(BeatLevel).map((lvl) => (
                <option key={lvl} value={lvl}>
                  {lvl}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className={styles.label}>Süre (saniye)</label>
            <input
              type="number"
              className={styles.input}
              value={duration}
              min="1"
              max="600"
              onChange={(e) => setDuration(parseInt(e.target.value) || 0)}
            />
          </div>
        </div>
        <div>
          <label className={styles.label}>Dosya Bağlantısı</label>
          <input
            className={styles.input}
            value={fileUrl}
            onChange={(e) => setFileUrl(e.target.value)}
          />
        </div>

        <div>
          <label className={styles.label}>
            Notes (JSON formatında - isteğe bağlı)
          </label>
          <textarea
            className={styles.input}
            style={{ height: "150px", fontFamily: "monospace" }}
            value={notesRaw}
            onChange={(e) => setNotesRaw(e.target.value)}
            placeholder='Boş bırakabilir veya şu formatta girebilirsiniz: [{"i":1,"sM":100,"eM":200,"led":[1,2]}]'
          />
        </div>

        <button type="submit" className={styles.button}>
          Kaydet
        </button>
      </form>
    </div>
  );
}
